module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "row"
  }, [(_vm.loading.email || _vm.loading.creatingEmail || _vm.loading.updatingEmail) ? _c('spinner') : _c('form', {
    attrs: {
      "data-vv-scope": "new-email"
    }
  }, [_c('div', {
    staticClass: "col-md-5"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "email-template"
    }
  }, [_vm._v("Template")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email.template_id),
      expression: "email.template_id"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "email-template"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.email, "template_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.applyTemplate]
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v("Select template...")]), _vm._v(" "), _vm._l((_vm.templates), function(template) {
    return _c('option', {
      domProps: {
        "value": template.id
      }
    }, [_vm._v(_vm._s(template.name))])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('new-email.new-email-subject')
    }
  }, [_c('label', {
    attrs: {
      "for": "email-body"
    }
  }, [_vm._v("* Subject")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email.subject),
      expression: "email.subject"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "rows": "2",
      "placeholder": "Subject",
      "name": "new-email-subject",
      "data-vv-as": "Subject",
      "disabled": _vm.email.status !== this.messagesStatuses.DRAFTING
    },
    domProps: {
      "value": (_vm.email.subject)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.email, "subject", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('new-email.new-email-subject')),
      expression: "errors.has('new-email.new-email-subject')"
    }],
    staticClass: "help-block"
  }, [_vm._v(_vm._s(_vm.errors.first('new-email.new-email-subject')))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('new-email.new-email-header')
    }
  }, [_c('label', {
    attrs: {
      "for": "email-header"
    }
  }, [_vm._v("* Header Banner")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email.header),
      expression: "email.header"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "email-header",
      "placeholder": "Header (Banner)",
      "name": "new-email-header",
      "data-vv-as": "Header Banner",
      "disabled": _vm.email.status !== this.messagesStatuses.DRAFTING
    },
    domProps: {
      "value": (_vm.email.header)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.email, "header", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('new-email.new-email-header')),
      expression: "errors.has('new-email.new-email-header')"
    }],
    staticClass: "help-block"
  }, [_vm._v(_vm._s(_vm.errors.first('new-email.new-email-header')))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('new-email.new-email-sincerely')
    }
  }, [_c('label', {
    attrs: {
      "for": "email-sender"
    }
  }, [_vm._v("* Sincerely,")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email.sender),
      expression: "email.sender"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "email-sender",
      "name": "new-email-sincerely",
      "data-vv-as": "Sincerely",
      "disabled": _vm.email.status !== this.messagesStatuses.DRAFTING
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.email, "sender", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "selected": ""
    },
    domProps: {
      "value": null
    }
  }, [_vm._v("Select option...")]), _vm._v(" "), _vm._l((_vm.newEmailOptions.senders), function(sender, senderKey) {
    return _c('option', {
      domProps: {
        "value": senderKey
      }
    }, [_vm._v(_vm._s(sender.name) + " <" + _vm._s(sender.email) + ">")])
  })], 2), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('new-email.new-email-sincerely')),
      expression: "errors.has('new-email.new-email-sincerely')"
    }],
    staticClass: "help-block"
  }, [_vm._v(_vm._s(_vm.errors.first('new-email.new-email-sincerely')))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('new-email.new-email-recipients-group')
    }
  }, [_c('label', {
    attrs: {
      "for": "email-recipients-group"
    }
  }, [_vm._v("* Recipient(s)")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email.recipients_group),
      expression: "email.recipients_group"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "email-recipients-group",
      "name": "new-email-recipients-group",
      "data-vv-as": "Recipient(s)",
      "disabled": _vm.email.status !== this.messagesStatuses.DRAFTING
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.email, "recipients_group", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.setRecipientsGroup]
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "selected": ""
    },
    domProps: {
      "value": null
    }
  }, [_vm._v("Select option...")]), _vm._v(" "), _vm._l((_vm.newEmailOptions.recipients_groups), function(groupName, groupKey) {
    return _c('option', {
      domProps: {
        "value": groupKey
      }
    }, [_vm._v("\n              " + _vm._s(groupName) + "\n            ")])
  })], 2), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('new-email.new-email-recipients-group')),
      expression: "errors.has('new-email.new-email-recipients-group')"
    }],
    staticClass: "help-block"
  }, [_vm._v(_vm._s(_vm.errors.first('new-email.new-email-recipients-group')))])]), _vm._v(" "), (_vm.email.recipients_group == 'users_by_role') ? _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('new-email.new-email-recipients-option')
    }
  }, [_c('label', {
    attrs: {
      "for": "email-recipients-by-role"
    }
  }, [_vm._v("* User Role")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email.recipients_option),
      expression: "email.recipients_option"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "email-recipients-by-role",
      "name": "new-email-recipients-option",
      "data-vv-as": "User Role",
      "disabled": _vm.email.status !== this.messagesStatuses.DRAFTING
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.email, "recipients_option", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.setRecipientsOption]
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "selected": ""
    },
    domProps: {
      "value": null
    }
  }, [_vm._v("Select option...")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "volunteers"
    }
  }, [_vm._v("Volunteer")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "case_managers"
    }
  }, [_vm._v("Case Manager")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "supervisors"
    }
  }, [_vm._v("Supervisor")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "program_administrators"
    }
  }, [_vm._v("Program Administrator")])]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('new-email.new-email-recipients-option')),
      expression: "errors.has('new-email.new-email-recipients-option')"
    }],
    staticClass: "help-block"
  }, [_vm._v(_vm._s(_vm.errors.first('new-email.new-email-recipients-option')))])]) : _vm._e(), _vm._v(" "), (_vm.email.recipients_group == 'users_by_account') ? _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('new-email.new-email-recipients-option')
    }
  }, [_c('label', {
    attrs: {
      "for": "email-recipients-by-account"
    }
  }, [_vm._v("* Accounts")]), _vm._v(" "), _c('vue-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "id": "email-recipients-by-account",
      "options": _vm.newEmailOptions.accounts,
      "label": "name",
      "name": "new-email-recipients-option",
      "data-vv-as": "User Account",
      "multiple": true,
      "disabled": _vm.email.status !== this.messagesStatuses.DRAFTING
    },
    on: {
      "change": _vm.setRecipientsOption
    },
    model: {
      value: (_vm.email.recipients_option),
      callback: function($$v) {
        _vm.$set(_vm.email, "recipients_option", $$v)
      },
      expression: "email.recipients_option"
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('new-email.new-email-recipients-option')),
      expression: "errors.has('new-email.new-email-recipients-option')"
    }],
    staticClass: "help-block"
  }, [_vm._v(_vm._s(_vm.errors.first('new-email.new-email-recipients-option')))])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('new-email.new-email-recipients')
    }
  }, [_c('label', [_vm._v("* Recipient(s)")]), _vm._v(" "), _c('vue-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|emails_arr'),
      expression: "'required|emails_arr'"
    }],
    attrs: {
      "options": _vm.recipientsInGroup,
      "multiple": true,
      "taggable": _vm.email.recipients_group == 'custom',
      "placeholder": "Select recipients...",
      "data-vv-name": "new-email-recipients",
      "data-vv-as": "Recipients",
      "disabled": _vm.email.status !== this.messagesStatuses.DRAFTING
    },
    model: {
      value: (_vm.email.recipients),
      callback: function($$v) {
        _vm.$set(_vm.email, "recipients", $$v)
      },
      expression: "email.recipients"
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('new-email.new-email-recipients')),
      expression: "errors.has('new-email.new-email-recipients')"
    }],
    staticClass: "help-block"
  }, [_vm._v(_vm._s(_vm.errors.first('new-email.new-email-recipients')))])], 1), _vm._v(" "), (_vm.email.hasOwnProperty('failedRecipients') && _vm.email.failedRecipients.length) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticStyle: {
      "color": "#f00"
    }
  }, [_vm._v("Failed recipient(s)")]), _vm._v(" "), _c('vue-select', {
    attrs: {
      "multiple": true,
      "disabled": true
    },
    model: {
      value: (_vm.email.failedRecipients),
      callback: function($$v) {
        _vm.$set(_vm.email, "failedRecipients", $$v)
      },
      expression: "email.failedRecipients"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.email.status == this.messagesStatuses.DRAFTING) ? _c('button', {
    staticClass: "btn green",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.saveEmail(true)
      }
    }
  }, [_vm._v("Send email")]) : _vm._e(), _vm._v(" "), (_vm.email.status == this.messagesStatuses.DRAFTING) ? _c('button', {
    staticClass: "btn default",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.saveEmail(false)
      }
    }
  }, [_vm._v("Save")]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn default",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.$emit('back')
      }
    }
  }, [_vm._v("Back")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-7"
  }, [_c('shortcodes-editor', {
    attrs: {
      "label": "Body",
      "name": "body",
      "validation-scope": "new-email",
      "validators": "required",
      "rows": "20",
      "shortcodes": _vm.shortcodes
    },
    model: {
      value: (_vm.email.body),
      callback: function($$v) {
        _vm.$set(_vm.email, "body", $$v)
      },
      expression: "email.body"
    }
  })], 1)])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-95412f6e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/emails/EditEmail.vue
// module id = 1724
// module chunks = 1